exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/src/index.js!../../node_modules/sass-loader/dist/cjs.js!@css/utils"), "");
// Module
exports.push([module.id, "html,body,.login-shell-login-shell-7HhGJfQ7mwr{min-height:100vh}body{background-color:white;margin:0px;display:flex;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\"}@media (min-width: 500px){body{background-color:#F2F2F2}}#app{flex:1}a,:visited{color:var(--link-text)}a:hover,:visited:hover{color:var(--link-text-hover)}.login-shell-login-shell-7HhGJfQ7mwr{flex-direction:column;align-items:stretch;width:100%;max-width:400px;margin:0 auto}@media (min-width: 500px){.login-shell-login-shell-7HhGJfQ7mwr{justify-content:center}}.login-shell-card-4by0yU6Nmwr{box-shadow:none}@media (min-width: 500px){.login-shell-card-4by0yU6Nmwr{box-shadow:0 3px 6px 0 rgba(0,0,0,0.1)}}.login-shell-logo-1dsUTTwQmwr{height:40px;margin-bottom:8px}.login-shell-links-area-3UWogxC9mwr{margin-top:20px;margin-bottom:20px;display:flex;flex-wrap:wrap;margin:0 -15px;padding:0 30px}.login-shell-links-area-3UWogxC9mwr a{font-size:14px;color:var(--secondary-text);text-decoration:none;margin:5px 15px;white-space:nowrap}@media (min-width: 500px){.login-shell-links-area-3UWogxC9mwr{padding:0 20%;justify-content:center;margin:20px 0}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"login-shell": "login-shell-login-shell-7HhGJfQ7mwr " + require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/src/index.js!../../node_modules/sass-loader/dist/cjs.js!@css/utils").locals["vertically-center"] + "",
	"loginShell": "login-shell-login-shell-7HhGJfQ7mwr " + require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/src/index.js!../../node_modules/sass-loader/dist/cjs.js!@css/utils").locals["vertically-center"] + "",
	"card": "login-shell-card-4by0yU6Nmwr",
	"logo": "login-shell-logo-1dsUTTwQmwr",
	"links-area": "login-shell-links-area-3UWogxC9mwr",
	"linksArea": "login-shell-links-area-3UWogxC9mwr"
};